import "./aboutpage.scss";
import vission from "../../../assets/images/about/vission.png";
import mission from "../../../assets/images/about/mission.png";
import { HeaderV1 } from '../header/headerv1';
import { FooterV1 } from '../footer/footerv1';
import { useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Context } from "Languages/Wrapper/Wrapper";
import React, { useRef, Component, useState, useEffect } from 'react';
import $ from 'jquery';
import { FormattedMessage, FormattedDate, FormattedNumber, FormattedPlural, FormattedTime, } from "react-intl";

export const Aboutpage = () => {
  const history = useHistory();
  const context = useContext(Context);

  /* Mission Section move from below to up at screen 575 */
  $(window).resize(function () {
    changeDiv();
  });
  useEffect(() => {
    changeDiv();
  });
  function changeDiv() {
    if ($(window).width() <= 575) {
      $('.before').insertBefore($('.after'));
    }
    else {
      $('.before').insertBefore($('.myContent'));
    }
  }

  return (
    <>
      <HeaderV1 />
      <section className="aboutus">
        <div className="container">
          <div className="aboutus_inner">
            <div className="row">
              <div className="col-sm-12">
                <div className="aboutus_banner_content">
                  <p className="about-text"><FormattedMessage id="aboutText" /> <span><FormattedMessage id="us" /></span></p>
                  <p className="about-tag">
                    <FormattedMessage
                      id="aboutTagLine"
                      defaultMessage="Making employment simpler, more social and supportive"
                    />
                  </p>
                  <p className="about-description">
                    <FormattedMessage
                      id="aboutPara"
                      defaultMessage="HUMLOGJOBS, a brand owned and operated by Parallel Platform Private Limited, is an employment platform designed to connect jobseekers with the right employment opportunities particularly blue-collar, entry-level and frontline jobs. HUMLOGJOBS combines a simple digital platform with a supportive physical ecosystem to bridge the gap between jobseekers and employers. We identify and connect emerging workforce from rural, urban and non-urban areas with employers looking for reliable and suitable talent. This combination of technology, human support and on-ground engagement helps address the real challenges faced by both jobseekers and employers. Parallel Platform Private Limited (CIN: U74999UP2021PTC140665) registered in Uttar Pradesh is DPIIT registered Startup (DIPP90953) supported by StartInUP and StartUP India and further funded by IIM Lucknow EIC, FITT IIT Delhi and SIDBI."
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vision_mission">
        <div className="container">
          <div className="vm_inner">
            <div className="row">
              <div className="col-sm-6">
                <div className="vm_img">
                  <img src={vission} alt="" className="img-fluid d-block" />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="vm_content">
                  <h3><FormattedMessage id="our" /> <span><FormattedMessage id="vision" /></span></h3>
                  <p>
                    <FormattedMessage
                      id="aboutVision"
                      defaultMessage="To connect people & businesses on their journey of economic growth & work life happiness"
                    />
                  </p>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="vm_content">
                  <div class="after"></div>
                  <h3><FormattedMessage id="our" /><span> <FormattedMessage id="mission" /></span></h3>
                  <p>
                    <FormattedMessage
                      id="aboutMission"
                      defaultMessage="To provide simple, social & supportive channel for employment connect to job seekers & employers"
                    />
                  </p>
                </div>
              </div>
              <div className="col-sm-6">
                <div class="myContent"></div>
                <div className="vm_img before">
                  <img src={mission} alt="" className="img-fluid d-block" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterV1 />
    </>
  );
};
